// @ts-check
import React from "react"
import { createTaskReportsCommonCells } from "../../../../../factories/reports/createTaskReportsCommonCells.factory"
import { BilledTimeCell } from "../../../../../components/molecules/reports/BilledTimeCell.molecule"
import { TimeDifferenceCell } from "../../../../../components/molecules/reports/TimeDifferenceCell.molecule"
import { numberFormatter } from "../../../../../utils/numbers.utils"
import { getTableColumnSumValue } from "../../../../../components/table/utils/tableColumns.utils"
import { TimeDifferenceBadge } from "../../../../../components/molecules/CellReportBadges.molecule"

/** @param {import("./ClientTasksTable.cells.types").ClientTasksTableCellsParams} params */
export function buildClientTasksTableCells(params) {
  const {
    isHoldingModifierDown,
    onLeftClickTeamMemberName,
    contextMenuRef,
    setContextMenuTarget,
    userIsAdmin,
    updatingTask,
  } = params

  const {
    DateCellTemplate,
    ProjectCodeCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
    ActionsCellTemplate,
  } = createTaskReportsCommonCells({
    isHoldingModifierDown,
    userIsAdmin,
    updatingTask,
    contextMenuRef,
    setContextMenuTarget,
  })

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableCellContext<string>} ctx */
  const TeamMemberCellTemplate = (ctx) => {
    const { row, getValue } = ctx
    const teamMemberNameTag = getValue()

    if (row.getIsGrouped()) {
      return null
    }

    return (
      <div
        className={`overflow-hidden white-space-nowrap text-overflow-ellipsis ${
          isHoldingModifierDown ? "ctrl-selectable" : ""
        }`}
        onClick={() => {
          if (isHoldingModifierDown) {
            onLeftClickTeamMemberName(ctx.table, teamMemberNameTag)
          }
        }}
        title={`${teamMemberNameTag} - ${row.original.teamMemberName} ${row.original.teamMemberLastName}`}
      >
        {`${teamMemberNameTag}`}
      </div>
    )
  }

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableHeaderContext<number>} ctx */
  const SisuTimeFooterTemplate = (ctx) => {
    const { table } = ctx

    const sisuTimeTotal = getTableColumnSumValue(table, "sisuTime")

    return numberFormatter(sisuTimeTotal)
  }

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableHeaderContext<number>} ctx */
  const BilledTimeFooterTemplate = (ctx) => {
    const { table } = ctx

    const billedTimeTotal = getTableColumnSumValue(table, "billedTime")

    return (
      <strong className="font-bold">
        {billedTimeTotal ? numberFormatter(billedTimeTotal) : "0"}
      </strong>
    )
  }

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableHeaderContext<number>} ctx */
  const TimeDifferenceFooterTemplate = (ctx) => {
    const { table } = ctx

    const timeDifferenceTotal = getTableColumnSumValue(table, "timeDifference")

    return (
      <div className="flex gap-1">
        <strong className="font-bold">
          {timeDifferenceTotal ? numberFormatter(timeDifferenceTotal) : "0"}
        </strong>
        {timeDifferenceTotal > 0 && (
          <TimeDifferenceBadge value={timeDifferenceTotal} />
        )}
      </div>
    )
  }

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableCellContext<number>} ctx */
  const BilledTimeCellTemplate = (ctx) => <BilledTimeCell ctx={ctx} />

  /** @param {import("./ClientTasksTable.controller.types").ClientTasksTableCellContext<number>} ctx */
  const TimeDifferenceCellTemplate = (ctx) => <TimeDifferenceCell ctx={ctx} />

  return {
    DateCellTemplate,
    ProjectCodeCellTemplate,
    TeamMemberCellTemplate,
    ModuleCellTemplate,
    CategoryCellTemplate,
    TaskCellTemplate,
    SisuTimeCellTemplate,
    SisuTimeFooterTemplate,
    BilledTimeCellTemplate,
    BilledTimeFooterTemplate,
    TimeDifferenceCellTemplate,
    TimeDifferenceFooterTemplate,
    ActionsCellTemplate,
  }
}
